/**
 * Lib.Common: Table component declarations
 */


import ibTable              from './ib-table.vue';
import ibTableBasic         from './ib-table-basic.vue';
import ibTableCol           from './ib-table-col.vue';
import ibTableGroup         from './ib-table-group.vue';
import ibTableSelect        from './ib-table-select.vue';


export default [
    ibTable,
    ibTableBasic,
    ibTableCol,
    ibTableGroup,
    ibTableSelect
];
